"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTenderFiles = exports.fetchSchema = exports.fetchReliablePartnerReport = exports.getTenderPendingFiles = exports.submitTender = exports.declineSection = exports.approveSection = exports.editNote = exports.addNote = exports.fetchNotes = exports.fetchTender = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const TypesLib = require("@caddigital/sok-types");
const ActionTypes = require("../../actionTypes/bid/tender");
const Actions = require("../../actions/bid/tender");
const _metaschema = require("../../modules/metaschema/epics");
const _fileList = require("../../modules/files/list/epics");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
function fetchTender(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant/${action.payload.participantId}`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const validation = t
            .intersection([
            t.interface({
                participant: sok_types_1.User.iUser,
                submitted: t.union([t.number, t.null]),
                company: t.union([t.string, t.null]),
                businessId: t.union([t.string, t.null])
            }),
            t.partial({
                tender: sok_types_1.File.iFolder,
                suitability: sok_types_1.File.iFolder,
                requestToParticipant: sok_types_1.File.iFolder,
                reliablePartner: sok_types_1.File.iFolder,
                reliablePartnerStatus: t.union([
                    TypesLib.Bid.iReliablePartnerStatus,
                    t.null
                ])
            })
        ])
            .decode(xhr.response);
        const act = validation.fold((e) => [Actions.fetchFailed((0, errorHandling_1.parseValidationError)(e))], (res) => {
            const acts = [
                Actions.fetchSuccess(res.participant, res.tender, res.suitability, res.requestToParticipant, res.reliablePartner, res.submitted, res.company, res.businessId, res.reliablePartnerStatus)
            ];
            return acts;
        });
        return (0, rxjs_1.of)(...act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchTender = fetchTender;
function fetchNotes(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_NOTES_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant/${action.payload.participantId}/note`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const validation = t.array(sok_types_1.Bid.iNote).decode(xhr.response);
        const act = validation.fold((e) => [Actions.fetchNotesFailed((0, errorHandling_1.parseValidationError)(e))], (res) => {
            const acts = [Actions.fetchNotesSuccess(res)];
            return acts;
        });
        return (0, rxjs_1.of)(...act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchNotesFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchNotes = fetchNotes;
function addNote(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.ADD_NOTE_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: { note: action.payload.note },
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant/${action.payload.participantId}/note`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return (0, rxjs_1.of)(Actions.addNoteSuccess(), Actions.fetchNotesRequest(action.payload.bid, action.payload.participantId));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.addNoteFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.addNote = addNote;
function editNote(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.EDIT_NOTE_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: action.payload.note,
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant/${action.payload.participantId}/note/${action.payload.note.id}`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return (0, rxjs_1.of)(Actions.editNoteSuccess(), Actions.fetchNotesRequest(action.payload.bid, action.payload.participantId));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.editNoteFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.editNote = editNote;
function approveSection(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.APPROVE_SECTION_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant/${action.payload.participant.id}/${action.section}/approve`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const actions = [
            Actions.approveSectionSuccess(action.section)
        ];
        const docs = store.value.bid.tender.documents;
        switch (action.section) {
            case 'requestToParticipant':
                docs.suitabilityRoot &&
                    actions.push(Actions.fetchFilesRequest(docs.suitabilityRoot.id, Actions.sortByOptions, Actions.searchOptions, undefined, 'suitability'));
                break;
            case 'suitability':
                docs.tenderRoot &&
                    actions.push(Actions.fetchFilesRequest(docs.tenderRoot.id, Actions.sortByOptions, Actions.searchOptions, undefined, 'tender'));
                break;
        }
        return (0, rxjs_1.of)(...actions);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.approveSectionFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.section))))));
}
exports.approveSection = approveSection;
function declineSection(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DECLINE_SECTION_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant/${action.payload.participant.id}/${action.section}/decline`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const actions = [
            Actions.declineSectionSuccess(action.section)
        ];
        const docs = store.value.bid.tender.documents;
        switch (action.section) {
            case 'requestToParticipant':
                docs.suitabilityRoot &&
                    actions.push(Actions.fetchFilesRequest(docs.suitabilityRoot.id, Actions.sortByOptions, Actions.searchOptions, undefined, 'suitability'));
            /* falls through */
            case 'suitability':
                docs.tenderRoot &&
                    actions.push(Actions.fetchFilesRequest(docs.tenderRoot.id, Actions.sortByOptions, Actions.searchOptions, undefined, 'tender'));
        }
        return (0, rxjs_1.of)(...actions);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.declineSectionFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.section))))));
}
exports.declineSection = declineSection;
function submitTender(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SUBMIT_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/bid/${action.payload.bid.id}/participant/${action.payload.participant.id}/submit`,
        body: {
            uploadSessions: action.payload.uploadSessions,
            removedFiles: action.payload.removedFiles,
            companyName: action.payload.companyName,
            businessId: action.payload.businessId
        }
    }).pipe((0, operators_1.mergeMap)((xhr) => (0, rxjs_1.of)(Actions.submitSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.submitFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.submitTender = submitTender;
function getTenderPendingFiles(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_PENDING_FILES_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: {
            type: 'SESSION',
            uuids: [action.payload]
        },
        url: `${baseUrl}api/files/metadata`
    }).pipe((0, operators_1.mergeMap)((xhr) => (0, rxjs_1.of)(Actions.fetchPendingFilesSuccess(xhr.response.list, action.section))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchPendingFilesFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.section))))));
}
exports.getTenderPendingFiles = getTenderPendingFiles;
const fetchReliablePartnerReport = (action$, _store, { ajax, getToken, baseUrl }) => {
    const getUrl = (bidId, participantId) => `${baseUrl}api/bid/${bidId}/participant/${participantId}/reliable-partner-report`;
    const ajaxOptions = (bidId, participantId) => ({
        method: 'POST',
        url: getUrl(bidId, participantId),
        headers: {
            Authorization: getToken(),
            'Content-Type': 'application/json'
        }
    });
    const ajaxCall = (bid, participantId) => ajax(ajaxOptions(bid.id, participantId)).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.fetchReliablePartnerReportSuccess())), (0, operators_1.catchError)((error) => {
        const responseError = (0, errorHandling_1.parseAjaxErrorResponse)(error);
        return (0, rxjs_1.of)(Actions.fetchReliablePartnerReportFailure(responseError));
    }));
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.FETCH_RELIABLE_PARTNER_REPORT_REQUEST), (0, operators_1.map)((action) => action), (0, operators_1.mergeMap)(({ payload: { bid, participant } }) => ajaxCall(bid, participant.id)));
};
exports.fetchReliablePartnerReport = fetchReliablePartnerReport;
const metaschema = _metaschema.default('tender-documents');
const fileList = _fileList.default('tender-documents', false);
exports.fetchSchema = metaschema.fetchSchema;
exports.getTenderFiles = fileList.fetch;
//# sourceMappingURL=tender.js.map